/* oddit-section-main-product — Interactive behavior */

(function () {
  const SECTION_SEL = '.oddit-section-main-product';

  // Height of whatever is stuck to the top of the viewport. The live theme header keeps
  // --sticky-area-height on :root (a calc over --header-is-sticky/--header-height, kept
  // live by its height-observer); a probe resolves that calc to px. Falls back to
  // measuring the Oddit header when that one is on the page instead.
  function stickyHeaderHeight() {
    var head = document.querySelector('.oddit-header--sticky');
    if (head) return head.getBoundingClientRect().height;
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;visibility:hidden;height:var(--sticky-area-height, 0px)';
    document.body.appendChild(probe);
    var h = probe.offsetHeight;
    probe.remove();
    return h;
  }

  function init(root) {
    if (!root) return;
    initGallery(root);
    initSwatches(root);
    initQuantity(root);
    initSkuMatch(root);
    initComplementaryProgress(root);
    initReviewsLink(root);
    initZoom(root);
    initTrustDrawers(root);
    initStickyLabel(root);
  }

  function initStickyLabel(root) {
    var source = root.querySelector('[data-buy-buttons] [data-add-to-cart]');
    var button = document.querySelector('[data-sticky-atc-button]');
    if (!source || !button) return;
    button.disabled = source.disabled;
    syncStickyLabel(button, source);
  }

  function initTrustDrawers(root) {
    root.querySelectorAll('.oddit-section-main-product__trust-drawer').forEach(function (drawer) {
      document.querySelectorAll('[id="' + drawer.id + '"]').forEach(function (el) {
        if (el !== drawer) el.remove();
      });
      document.body.appendChild(drawer);
    });
  }

  var ZOOM_IMG_SEL = '.oddit-section-main-product__main-image, .oddit-section-main-product__gallery-stack-img';
  var zoomView = null;

  function zoomSrc(img) {
    var src = img.currentSrc || img.getAttribute('src') || '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=2400') : src;
  }

  function buildZoomView() {
    var el = document.createElement('div');
    el.className = 'oddit-product-zoom';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Product image zoom');
    el.hidden = true;
    el.innerHTML =
      '<div class="oddit-product-zoom__stage"><img class="oddit-product-zoom__img" alt=""></div>' +
      '<div class="oddit-product-zoom__controls">' +
      '<button type="button" class="oddit-product-zoom__btn oddit-product-zoom__btn--nav" data-zoom-prev aria-label="Previous image">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M10 3L5 8L10 13" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" class="oddit-product-zoom__btn oddit-product-zoom__btn--close" data-zoom-close aria-label="Close zoom">' +
      '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M3 3L15 15M15 3L3 15" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg></button>' +
      '<button type="button" class="oddit-product-zoom__btn oddit-product-zoom__btn--nav" data-zoom-next aria-label="Next image">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '</div>';
    document.body.appendChild(el);

    var view = {
      el: el,
      stage: el.querySelector('.oddit-product-zoom__stage'),
      img: el.querySelector('.oddit-product-zoom__img'),
      prev: el.querySelector('[data-zoom-prev]'),
      next: el.querySelector('[data-zoom-next]'),
      sources: [],
      index: 0,
      opener: null,
    };

    function setOrigin(e) {
      var r = view.img.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
      var y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
      view.img.style.transformOrigin = x + '% ' + y + '%';
    }

    view.img.addEventListener('click', function (e) {
      setOrigin(e);
      el.classList.toggle('is-zoomed');
    });

    view.stage.addEventListener('pointermove', function (e) {
      if (el.classList.contains('is-zoomed')) setOrigin(e);
    });

    view.stage.addEventListener('click', function (e) {
      if (e.target === view.stage) closeZoom();
    });

    el.querySelector('[data-zoom-close]').addEventListener('click', closeZoom);
    view.prev.addEventListener('click', function () { showZoom(view.index - 1); });
    view.next.addEventListener('click', function () { showZoom(view.index + 1); });

    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeZoom();
      else if (e.key === 'ArrowLeft') showZoom(view.index - 1);
      else if (e.key === 'ArrowRight') showZoom(view.index + 1);
    });

    return view;
  }

  function showZoom(i) {
    var total = zoomView.sources.length;
    if (!total) return;
    zoomView.index = (i + total) % total;
    zoomView.el.classList.remove('is-zoomed');
    zoomView.img.style.transformOrigin = '';
    zoomView.img.src = zoomView.sources[zoomView.index].src;
    zoomView.img.alt = zoomView.sources[zoomView.index].alt;
  }

  function openZoom(images, index) {
    if (!zoomView) zoomView = buildZoomView();
    zoomView.sources = images.map(function (img) {
      return { src: zoomSrc(img), alt: img.getAttribute('alt') || '' };
    });
    var single = zoomView.sources.length < 2;
    zoomView.prev.hidden = single;
    zoomView.next.hidden = single;
    zoomView.opener = document.activeElement;
    showZoom(index);
    zoomView.el.hidden = false;
    document.documentElement.classList.add('oddit-product-zoom-open');
    requestAnimationFrame(function () {
      zoomView.el.classList.add('is-open');
      zoomView.el.querySelector('[data-zoom-close]').focus({ preventScroll: true });
    });
  }

  function closeZoom() {
    if (!zoomView || zoomView.el.hidden) return;
    zoomView.el.classList.remove('is-open', 'is-zoomed');
    zoomView.el.hidden = true;
    document.documentElement.classList.remove('oddit-product-zoom-open');
    if (zoomView.opener && zoomView.opener.focus) zoomView.opener.focus({ preventScroll: true });
  }

  function initZoom(root) {
    var gallery = root.querySelector('.oddit-section-main-product__gallery');
    if (!gallery || gallery.dataset.zoomBound) return;
    gallery.dataset.zoomBound = 'true';

    gallery.addEventListener('click', function (e) {
      var img = e.target.closest(ZOOM_IMG_SEL);
      if (!img) return;
      var slides = [].slice.call(gallery.querySelectorAll('.oddit-section-main-product__main-image'));
      var stack = [].slice.call(gallery.querySelectorAll('.oddit-section-main-product__gallery-stack-img'));
      var index = slides.indexOf(img);
      if (index === -1) index = stack.indexOf(img) + 1;
      openZoom(slides.length ? slides : [img], Math.max(0, index));
    });
  }

  var REVIEWS_TARGETS = [
    '#oddit-product-reviews',
    '#klaviyo-reviews-all',
    '[id^="shopify-block-"][id*="klaviyo_reviews_product_reviews"]',
    '[id^="shopify-block-"][id*="product_reviews"]',
    '.klaviyo-reviews-widget',
  ];

  function findReviews() {
    for (var i = 0; i < REVIEWS_TARGETS.length; i++) {
      var el = document.querySelector(REVIEWS_TARGETS[i]);
      if (el) return el;
    }
    return null;
  }

  function initReviewsLink(root) {
    if (root.dataset.reviewsLinkBound) return;
    root.dataset.reviewsLinkBound = 'true';

    root.addEventListener('click', function (e) {
      var badge = e.target.closest('[data-reviews-badge]');
      if (!badge) return;
      var target = findReviews();
      if (!target) return;
      e.preventDefault();
      var head = document.querySelector('.oddit-header--sticky');
      var offset = head ? Math.max(0, head.getBoundingClientRect().bottom) : stickyHeaderHeight();
      var top = window.pageYOffset + target.getBoundingClientRect().top - offset - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  }

  function initQuantity(root) {
    var picker = root.querySelector('[data-product-quantity]');
    if (!picker) return;

    var input = picker.querySelector('[data-quantity-input]');
    var minus = picker.querySelector('[data-quantity-step="-1"]');
    var plus = picker.querySelector('[data-quantity-step="1"]');
    if (!input) return;
    // Set from Liquid only when Shopify tracks stock and won't oversell this variant.
    var max = parseInt(input.max, 10) || Infinity;

    function sync() {
      var value = Math.min(max, Math.max(1, parseInt(input.value, 10) || 1));
      input.value = value;
      if (minus) minus.disabled = value <= 1;
      if (plus) plus.disabled = value >= max;
      root.querySelectorAll('[data-buy-buttons] [data-add-to-cart]').forEach(function (btn) {
        btn.dataset.quantity = value;
      });
      var sticky = document.querySelector('[data-sticky-atc-button]');
      if (sticky) sticky.dataset.quantity = value;
    }

    picker.addEventListener('click', function (e) {
      var step = e.target.closest('[data-quantity-step]');
      if (!step) return;
      input.value = (parseInt(input.value, 10) || 1) + Number(step.getAttribute('data-quantity-step'));
      sync();
    });

    input.addEventListener('change', sync);
    input.addEventListener('blur', sync);
    sync();
  }

  /* ---- Gallery: main track ⇄ thumbnails ⇄ arrow ---- */
  function initGallery(root) {
    var ACTIVE = 'oddit-section-main-product__thumbnail--active';
    var track = root.querySelector('.oddit-section-main-product__main-image-wrap');
    var thumbs = root.querySelectorAll('.oddit-section-main-product__thumbnail');
    var prevBtn = root.querySelector('.oddit-section-main-product__gallery-prev');
    var nextBtn = root.querySelector('.oddit-section-main-product__gallery-next');
    if (!track || thumbs.length === 0) return;

    var stack = root.querySelector('.oddit-section-main-product__gallery-stack');
    var stackImgs = stack
      ? [].slice.call(stack.querySelectorAll('.oddit-section-main-product__gallery-stack-img'))
      : [];

    var index = 0;
    var rail = thumbs[0].parentNode;
    var animating = false;
    var settle = null;

    function mark(i) {
      index = Math.max(0, Math.min(i, thumbs.length - 1));
      thumbs.forEach(function (t, n) { t.classList.toggle(ACTIVE, n === index); });
    }

    // Centre the active thumb in the rail, without ever scrolling an ancestor.
    // scrollBy clamps at the ends, so the first/last thumbs settle at the gutter.
    function revealThumb() {
      var r = rail.getBoundingClientRect();
      var t = thumbs[index].getBoundingClientRect();
      if (rail.scrollHeight > rail.clientHeight) {
        var dy = t.top + t.height / 2 - (r.top + r.height / 2);
        if (dy) rail.scrollBy({ top: dy, behavior: 'smooth' });
        return;
      }
      if (rail.scrollWidth <= rail.clientWidth) return;
      var delta = t.left + t.width / 2 - (r.left + r.width / 2);
      if (delta) rail.scrollBy({ left: delta, behavior: 'smooth' });
    }

    function release() {
      animating = false;
      clearTimeout(settle);
    }

    function stacked() {
      return stack && getComputedStyle(stack).display !== 'none';
    }

    function panelFor(i) {
      return i <= 0 ? track : stackImgs[i - 1] || null;
    }

    function panels() {
      return [track].concat(stackImgs);
    }

    function syncStickyTop() {
      root.style.setProperty('--oddit-gallery-sticky-top', stickyHeaderHeight() + 12 + 'px');
    }
    syncStickyTop();
    window.addEventListener('resize', syncStickyTop, { passive: true });

    function scrollToPanel(i) {
      var el = panelFor(i);
      if (!el) return;
      var top = window.pageYOffset + el.getBoundingClientRect().top - stickyHeaderHeight() - 8;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    function goTo(i) {
      mark(i);
      revealThumb();
      // Our own smooth scroll must not be read back as user input.
      if (stacked()) {
        animating = true;
        clearTimeout(settle);
        settle = setTimeout(release, 900);
        scrollToPanel(index);
        return;
      }
      if (track.scrollWidth <= track.clientWidth) return;
      animating = true;
      clearTimeout(settle);
      settle = setTimeout(release, 700);
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { goTo(i); });
    });

    track.addEventListener('scrollend', release);

    // Swiping / dragging the track is the source of truth for the active thumb.
    var raf = null;
    track.addEventListener('scroll', function () {
      if (animating || raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        if (track.clientWidth === 0) return;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) { mark(i); revealThumb(); }
      });
    }, { passive: true });

    var spy = null;
    window.addEventListener('scroll', function () {
      if (animating || spy || !stacked()) return;
      spy = requestAnimationFrame(function () {
        spy = null;
        var probe = window.innerHeight * 0.4;
        var best = -1;
        var bestDist = Infinity;
        panels().forEach(function (el, n) {
          var r = el.getBoundingClientRect();
          if (r.bottom <= 0 || r.top >= window.innerHeight) return;
          var d = Math.abs(r.top - probe);
          if (d < bestDist) { bestDist = d; best = n; }
        });
        if (best !== -1 && best !== index) { mark(best); revealThumb(); }
      });
    }, { passive: true });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
  }

  /* ---- Colour swatch click → select the variant ---- */
  function initSwatches(root) {
    var ACTIVE = 'oddit-section-main-product__swatch--active';
    var swatches = root.querySelectorAll('.oddit-section-main-product__swatch');
    var label = root.querySelector('.oddit-section-main-product__color-value');
    if (swatches.length === 0) return;

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        swatches.forEach(function (s) {
          s.classList.remove(ACTIVE);
          s.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add(ACTIVE);
        btn.setAttribute('aria-pressed', 'true');
        if (label && btn.dataset.color) label.textContent = btn.dataset.color;
        if (btn.dataset.variantId) selectVariant(root, btn.dataset.variantId);
      });

      if (btn.dataset.variantId) {
        btn.addEventListener('pointerenter', function () {
          fetchSection(root, btn.dataset.variantId).then(warmFirstImage);
        });
      }
    });
  }

  /* ---- Variant change ---- */
  // Gallery media is filtered per variant server-side (see the section Liquid), so
  // switching variants means re-rendering the section rather than toggling DOM we
  // never shipped. ?variant= is what the server reads, so it doubles as the URL state.

  // One request per variant, kept for the life of the page so switching back is free.
  var sectionCache = {};

  function fetchSection(root, variantId) {
    if (sectionCache[variantId]) return sectionCache[variantId];

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', root.id);

    sectionCache[variantId] = fetch(url.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
      .catch(function () {
        delete sectionCache[variantId];
        return null;
      });

    return sectionCache[variantId];
  }

  // The incoming markup is fresh <img> tags, so without this the swap shows an empty
  // gallery until they download. Decoding a detached copy first puts them in the
  // browser cache, and the real ones then paint on the same frame they are inserted.
  function warmFirstImage(doc) {
    var img = doc && doc.querySelector('.oddit-section-main-product__gallery img[src]');
    if (!img) return Promise.resolve();

    var probe = new Image();
    if (img.getAttribute('sizes')) probe.sizes = img.getAttribute('sizes');
    if (img.getAttribute('srcset')) probe.srcset = img.getAttribute('srcset');
    probe.src = img.getAttribute('src');

    if (!probe.decode) return Promise.resolve();
    return probe.decode().catch(function () {});
  }

  function selectVariant(root, variantId) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);

    document.dispatchEvent(new CustomEvent('oddit:variant-change', { detail: { variantId: String(variantId) } }));

    fetchSection(root, variantId).then(function (doc) {
      if (!doc || !doc.querySelector('.oddit-section-main-product__gallery')) return;
      // A later click wins: only paint if this variant is still the selected one.
      if (new URL(window.location.href).searchParams.get('variant') !== String(variantId)) return;

      return warmFirstImage(doc).then(function () {
        ['.oddit-section-main-product__gallery', '[data-product-price]', '[data-buy-buttons]', '[data-product-upc]'].forEach(
          function (sel) {
            var from = doc.querySelector(sel);
            var to = root.querySelector(sel);
            if (from && to) to.innerHTML = from.innerHTML;
          }
        );

        var nextLabel = doc.querySelector('[data-product-label]');
        var label = root.querySelector('[data-product-label]');
        if (nextLabel && label) {
          label.innerHTML = nextLabel.innerHTML;
          label.hidden = nextLabel.hidden;
        }

        swapComplementary(root, doc);
        initGallery(root);
        initQuantity(root);
        syncStickyAtc(root);
        // Re-arms the reveal/drag-scroll bindings the interactions script attaches to
        // replaced markup; it listens for this on document, main-product.js ignores it
        // because the target is not a section root.
        root
          .querySelector('.oddit-section-main-product__gallery')
          .dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      });
    });
  }

  function swapComplementary(root, doc) {
    var from = doc.querySelector('[data-complementary-products]');
    var to = root.querySelector('[data-complementary-products]');
    if (!from || !to) return;
    if (from.hasAttribute('data-url') && to.hasAttribute('data-url') && from.dataset.skuMatch === to.dataset.skuMatch) return;

    var next = document.importNode(from, true);
    next.classList.add('is-visible');
    to.replaceWith(next);
    initSkuMatch(root);
    initComplementaryProgress(root);
    next.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
  }

  // The sticky bar is its own section, so it is not part of the fetched markup.
  function syncStickyAtc(root) {
    var source = root.querySelector('[data-buy-buttons] [data-add-to-cart]');
    var button = document.querySelector('[data-sticky-atc-button]');
    var price = document.querySelector('[data-sticky-atc-price]');
    if (!source) return;
    if (button) {
      button.dataset.variantId = source.dataset.variantId;
      button.dataset.quantity = source.dataset.quantity || '1';
      button.disabled = source.disabled;
      syncStickyLabel(button, source);
    }
    var newPrice = root.querySelector('[data-product-price]');
    if (price && newPrice) price.textContent = newPrice.textContent.trim();
  }

  function syncStickyLabel(button, source) {
    var label = button.querySelector('[data-button-label]');
    if (!label || !button.dataset.labelDesktop) return;

    label.textContent = '';
    if (source.disabled) {
      label.textContent = 'Sold out';
      return;
    }

    var preorder = source.hasAttribute('data-preorder');
    [
      ['oddit-section-sticky-atc__label-mobile', preorder ? button.dataset.labelPreorder : button.dataset.labelMobile],
      ['oddit-section-sticky-atc__label-desktop', preorder ? button.dataset.labelPreorder : button.dataset.labelDesktop]
    ].forEach(function (part) {
      var span = document.createElement('span');
      span.className = part[0];
      span.textContent = part[1];
      label.appendChild(span);
    });
  }

  /* ---- Complementary products: complementary / related recommendations ---- */
  // A custom product list is rendered server-side and carries no data-url, so this
  // is a no-op for it. The other two intents need the Product Recommendations API,
  // which renders this section with the recommendations object populated.
  function initComplementary(root) {
    var host = root.querySelector('[data-complementary-products][data-url]');
    if (!host) return;

    var grid = host.querySelector('.oddit-section-main-product__complementary-grid');
    if (!grid || grid.children.length) return;

    var url =
      host.dataset.url +
      '?section_id=' + encodeURIComponent(host.dataset.sectionId) +
      '&product_id=' + encodeURIComponent(host.dataset.productId) +
      '&limit=' + encodeURIComponent(host.dataset.limit) +
      '&intent=' + encodeURIComponent(host.dataset.intent);

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('.oddit-section-main-product__complementary-grid');
        if (!next || !next.children.length) {
          host.hidden = true;
          return;
        }

        grid.innerHTML = next.innerHTML;
        host.hidden = false;
        initComplementaryProgress(root);
        grid.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      })
      .catch(function () {
        host.hidden = true;
      });
  }

  var skuMatchRequests = (window.odditSkuMatchRequests = window.odditSkuMatchRequests || {});

  function fetchSkuMatch(searchUrl, sku) {
    var url =
      searchUrl +
      '?q=' + encodeURIComponent('variants.sku:' + sku) +
      '&type=product' +
      '&options[prefix]=none' +
      '&section_id=oddit-section-sku-match';

    if (!skuMatchRequests[url]) {
      skuMatchRequests[url] = fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
        .catch(function () {
          delete skuMatchRequests[url];
          return null;
        });
    }
    return skuMatchRequests[url];
  }

  function skuMatchCards(doc, currentProductId, listKey) {
    if (!doc) return [];
    var matches = Array.prototype.slice.call(doc.querySelectorAll('[data-sku-match-product]')).filter(function (el) {
      return el.dataset.skuMatchProduct !== String(currentProductId);
    });
    matches.sort(function (a, b) {
      return (a.dataset.skuMatchGroup === 'true') - (b.dataset.skuMatchGroup === 'true');
    });
    for (var i = 0; i < matches.length; i++) {
      var list = matches[i].querySelector('[data-sku-match-list="' + listKey + '"]');
      if (list && list.children.length) return Array.prototype.slice.call(list.children);
    }
    return [];
  }

  function initSkuMatch(root) {
    var host = root.querySelector('[data-complementary-products][data-sku-match]');
    if (!host || host.dataset.skuMatchDone === 'true') {
      initComplementary(root);
      return;
    }
    host.dataset.skuMatchDone = 'true';

    fetchSkuMatch(host.dataset.skuMatchUrl, host.dataset.skuMatch).then(function (doc) {
      if (!host.isConnected) return;
      var grid = host.querySelector('.oddit-section-main-product__complementary-grid');
      var limit = parseInt(host.dataset.limitCount, 10) || 4;
      var cards = skuMatchCards(doc, host.dataset.currentProductId, 'complete_the_look').slice(0, limit);

      if (grid && cards.length) {
        grid.innerHTML = '';
        cards.forEach(function (card) {
          var added = document.importNode(card, true);
          added.querySelectorAll('[data-button-label]').forEach(function (label) {
            label.textContent = host.dataset.addLabel || 'ADD';
          });
          grid.appendChild(added);
        });
        host.hidden = false;
        initComplementaryProgress(root);
        grid.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        return;
      }

      if (grid && grid.children.length) {
        host.hidden = false;
        initComplementaryProgress(root);
        return;
      }

      initComplementary(root);
    });
  }

  /* ---- Complementary carousel → progress bar ---- */
  function initComplementaryProgress(root) {
    var track = root.querySelector('.oddit-section-main-product__complementary-grid');
    var wrap = root.querySelector('.oddit-section-main-product__complementary-progress');
    var bar = root.querySelector('.oddit-section-main-product__complementary-progress-bar');
    var navs = root.querySelectorAll('[data-complementary-nav]');
    if (!track || !bar) return;

    function syncNav(overflow) {
      var image = track.querySelector('.oddit-section-main-product__comp-card-image');
      navs.forEach(function (nav) {
        var dir = Number(nav.dataset.complementaryNav);
        nav.hidden = dir < 0 ? track.scrollLeft <= 1 : track.scrollLeft >= overflow - 1;
        if (image) nav.style.top = image.offsetHeight / 2 + 'px';
      });
    }

    function sync() {
      var overflow = track.scrollWidth - track.clientWidth;
      syncNav(overflow);
      // Nothing to scroll (fewer cards than fit): no progress to report.
      if (overflow <= 1) {
        if (wrap) wrap.style.visibility = 'hidden';
        return;
      }
      if (wrap) wrap.style.visibility = '';
      var visible = track.clientWidth / track.scrollWidth;
      bar.style.width = visible * 100 + '%';
      bar.style.left = (track.scrollLeft / overflow) * (100 - visible * 100) + '%';
    }

    navs.forEach(function (nav) {
      if (nav.dataset.bound) return;
      nav.dataset.bound = 'true';
      nav.addEventListener('click', function () {
        var card = track.querySelector('.oddit-section-main-product__comp-card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var step = card ? card.offsetWidth + gap : track.clientWidth;
        track.scrollBy({ left: step * Number(nav.dataset.complementaryNav), behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', sync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
    sync();
  }

  /* ---- Section lifecycle ---- */
  var section = document.querySelector(SECTION_SEL);
  if (section) init(section);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector(SECTION_SEL);
    if (s) init(s);
  });
})();